import { useState } from "react";
import AddNew from "./AddNew";
import List from "./List";
import startOfToday from "date-fns/esm/startOfToday/index.js";
import AllySettlement from "./AllySettlement";
import AllyFilter from "./AllyFilter";


export default function Allies() {
    const [day, setDay] = useState<Date>(startOfToday())
    const [endDay, setEndDay] = useState<Date>()
    const [allyId, setAllyId] = useState<string>()
    return (
        <>
            <AddNew/>
            <AllyFilter
            day={day}
            setDay={setDay}
            endDay={endDay}
            setEndDay={setEndDay}
            setAllyId={setAllyId}
            />
            {
                // Resumen de lo que el aliado debe (costo + entrada por pasajero) — reemplaza el
                // reporte de comisiones: con precio confidencial los aliados ya no llevan comisión.
                allyId &&
                <AllySettlement
                day={day}
                endDay={endDay}
                setDay={setDay}
                setEndDay={setEndDay}
                id={allyId}
                />
            }
            <List/>
        </>
    )
}
